import axios from 'axios';
import { createHashHistory } from 'history';
import { handleMessage } from './request';

const root = process.env.REACT_APP_BASEURL;

let all = async function () {
  const funcs = [...arguments];
  return new Promise((resolve, reject) => {
    axios
      .all(funcs)
      .then(res => {
        res.map((item, index) => {
          if (item.data.code === 401) {
            const history = createHashHistory();
            history.push('/login');
            return false;
          }
        });
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
};

// post请求
let post = async function (url, params) {
  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      url: url,
      baseURL: root,
      data: params,
      withCredentials: true,
      timeout: 600000,
    })
      .then(res => {
        if (res.data.code == 401) {
          const history = createHashHistory();
          history.push('/login');
        } else {
          resolve(res);
        }
      })
      .catch(err => {
        reject(err);
      });
  });
};

// get请求
let get = async function (url, params) {
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url: url,
      baseURL: root,
      withCredentials: true,
      params: params,
    })
      .then(res => {
        if (res.data.code == 401) {
          const history = createHashHistory();
          history.push('/login');
        } else {
          resolve(res);
        }
      })
      .catch(err => {
        reject(err);
      });
  });
};

// put请求
let put = async function (url, params) {
  return new Promise((resolve, reject) => {
    axios({
      method: 'put',
      url: url,
      baseURL: root,
      withCredentials: true,
      data: params,
    })
      .then(res => {
        if (res.data.code == 401) {
          const history = createHashHistory();
          history.push('/login');
        } else {
          resolve(res);
        }
      })
      .catch(err => {
        reject(err);
      });
  });
};
// put请求
let Delete = async function (url, params) {
  return new Promise((resolve, reject) => {
    axios({
      method: 'delete',
      url: url,
      baseURL: root,
      withCredentials: true,
      params: params,
    })
      .then(res => {
        if (res.data.code == 401) {
          const history = createHashHistory();
          history.push('/login');
        } else {
          resolve(res);
        }
      })
      .catch(err => {
        reject(err);
      });
  });
};

/**
 * 从正常返回的接口中取出数据，并整理错误信息
 * @param request
 * @param code 正常返回的 code 值，默认为 200
 * @returns {*}
 */
const handleRequestData = (mapping, request, code = 200) => {
  return request.then(
    response => {
      if (response.data[mapping.code] === code) {
        return response.data.data;
      } else {
        throw new Error(response.data[mapping.msg]);
      }
    },
    error => {
      const status = error?.response?.status;
      if (status) {
        throw new Error(`网络错误: ${status}`);
      } else {
        throw new Error(`未知错误: ${error?.toString()}`);
      }
    },
  );
};

const getRequestData = (request, options = {}, code = 0) => {
  const { mapping, errorHandler = handleMessage, useDefaultErrorHandler = true } = options;

  const result = handleRequestData(mapping || { code: 'status_code', msg: 'status_msg' }, request, code);

  if (useDefaultErrorHandler) {
    return result.catch(errorHandler);
  }

  return result;
};

export const http = { all, post, get, put, Delete, getRequestData };
